export default __webpack_public_path__ + "static/media/Seminarhaus_Hof.c119e74a.webp";